module.exports = __webpack_public_path__ + "static/media/2020-dec-3.328254b4.png";